import { SvgIcon, type SvgIconProps } from '@mui/material';

export function LogoHomeConnect({ sx, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 418.333 158"
      sx={{ width: 250, height: 94.5, ...sx }}
      titleAccess="Homere Connect logo"
      {...props}
    >
      <g>
        <g>
          <path
            fill="#3C71A4"
            d="M247.337,41.455c-2.047-4.186-4.969-7.506-8.688-9.87c-3.727-2.364-7.99-3.562-12.738-3.562
            c-4.68,0.009-8.964,1.156-12.737,3.408c-2.264,1.35-4.244,3.018-5.922,4.984c-1.639-1.943-3.551-3.592-5.717-4.927
            c-3.646-2.248-7.797-3.388-12.395-3.388c-3.697,0.008-7.215,0.817-10.453,2.405c-1.016,0.499-1.985,1.062-2.903,1.688
            c-0.334-0.663-0.742-1.174-1.121-1.553c-0.822-0.814-2.287-1.785-4.619-1.785c-1.738,0.004-3.289,0.604-4.492,1.74
            c-0.875,0.829-1.918,2.315-1.91,4.691l0.105,49.736c0.002,1.781,0.646,3.361,1.859,4.566c1.211,1.203,2.785,1.84,4.555,1.84h0.02
            c2.377-0.01,3.857-1.055,4.686-1.938c1.123-1.203,1.717-2.756,1.715-4.495l-0.066-31.25c-0.008-3.877,1.134-6.913,3.491-9.281
            c2.357-2.367,5.355-3.522,9.188-3.531c3.334,0,5.994,1.238,8.135,3.785c2.297,2.736,3.42,6.239,3.428,10.71l0.064,29.513
            c0.002,1.785,0.646,3.365,1.854,4.56c1.207,1.207,2.783,1.846,4.574,1.846c2.381-0.006,3.863-1.055,4.678-1.926
            c1.133-1.201,1.729-2.758,1.727-4.505l-0.064-30.318c-0.123-4.297,0.945-7.597,3.266-10.088c2.279-2.451,5.252-3.646,9.109-3.655
            c3.33,0,5.99,1.239,8.131,3.785c2.299,2.737,3.422,6.24,3.432,10.711l0.062,29.508c0,1.787,0.645,3.369,1.857,4.57
            c1.209,1.203,2.785,1.84,4.572,1.84c2.381-0.004,3.861-1.055,4.682-1.93c1.127-1.199,1.725-2.754,1.725-4.5l-0.064-29.517
            C250.347,50.198,249.332,45.533,247.337,41.455z M170.162,88.072L170.162,88.072v0.002V88.072z"
          />
          <path
            fill="#3C71A4"
            d="M281.107,24.149l0.398,0.338c1.326,0.962,2.707,1.45,4.105,1.45h0.01h0.004
            c1.814-0.003,3.416-0.688,4.637-1.985c1.16-1.24,1.771-2.812,1.77-4.547c-0.006-2.242-0.93-3.634-1.707-4.41l-12.59-12.537
            c-1.244-1.237-2.803-1.891-4.52-1.891c-1.773,0.004-3.367,0.663-4.617,1.913c-1.242,1.249-1.895,2.85-1.887,4.615
            c0,1.779,0.625,3.341,1.807,4.519L281.107,24.149z"
          />
          <path
            fill="#3C71A4"
            d="M300.794,32.087c-4.412-2.634-9.453-3.969-15.061-3.969c-5.703,0.011-10.873,1.406-15.367,4.145
            c-4.498,2.744-8.035,6.603-10.518,11.473c-2.436,4.791-3.664,10.272-3.65,16.292c0.014,5.997,1.367,11.47,4.027,16.264
            c2.678,4.842,6.426,8.669,11.139,11.374c4.668,2.682,10.035,4.041,15.951,4.041h0.082c3.584-0.008,7.357-0.738,11.215-2.172
            c3.891-1.443,7.125-3.322,9.609-5.583l0.119-0.113c1.568-1.575,1.895-3.218,1.893-4.317c-0.004-1.282-0.416-3.143-2.309-4.688
            c-1.082-0.921-2.467-1.409-4.02-1.409c-1.508,0.003-2.975,0.544-4.24,1.565l-0.219,0.192c-1.201,1.154-2.932,2.125-5.143,2.886
            c-2.326,0.8-4.66,1.208-6.98,1.213c-3.385,0-6.348-0.725-9.057-2.216c-2.703-1.489-4.805-3.512-6.424-6.188
            c-1.061-1.753-1.805-3.633-2.25-5.686l38.994-0.083c1.732-0.004,3.264-0.584,4.432-1.682c0.854-0.803,1.871-2.242,1.871-4.545
            c-0.014-5.832-1.256-11.13-3.689-15.747C308.73,38.452,305.23,34.735,300.794,32.087z M297.107,44.87
            c2.268,2.217,3.781,4.932,4.582,8.237l-31.771,0.067c0.9-3.296,2.473-6.015,4.756-8.245c3.014-2.942,6.641-4.377,11.088-4.386
            l0.049-3.351l0,0v3.351C290.427,40.542,294.125,41.958,297.107,44.87z M287.316,88.352L287.316,88.352v0.002V88.352z"
          />
          <path
            fill="#3C71A4"
            d="M358.74,34.601c-0.006-3.057-1.926-6.701-11.127-6.701c-4.189,0.009-8.119,1.062-11.684,3.131
            c-0.98,0.57-1.914,1.202-2.801,1.895c-0.352-1.191-0.975-2.031-1.531-2.586c-0.82-0.813-2.287-1.783-4.617-1.783
            c-1.738,0.004-3.291,0.605-4.49,1.739c-0.875,0.828-1.916,2.313-1.912,4.691l0.105,49.73c0,1.779,0.643,3.359,1.855,4.566
            c1.207,1.207,2.783,1.844,4.559,1.844h0.018c2.373-0.004,3.855-1.049,4.688-1.934c1.127-1.203,1.719-2.758,1.717-4.496
            l-0.068-31.047c-0.004-2.545,0.57-4.759,1.76-6.768c1.191-2.009,2.803-3.545,4.932-4.696c2.178-1.178,4.629-1.754,7.518-1.76
            c0.512,0,1.193,0.057,2.021,0.169c1.137,0.154,2.061,0.229,2.859,0.229c1.436-0.002,2.68-0.359,3.695-1.064
            c1.084-0.754,1.848-1.896,2.268-3.391C358.664,35.848,358.74,35.27,358.74,34.601z M327.097,87.773L327.097,87.773L327.097,87.773
            L327.097,87.773z"
          />
          <path
            fill="#3C71A4"
            d="M414.738,63.238c0.848-0.806,1.859-2.246,1.854-4.535c-0.014-5.836-1.252-11.134-3.686-15.748
            c-2.471-4.681-5.973-8.397-10.408-11.047c-4.41-2.635-9.453-3.97-15.059-3.97c-5.705,0.013-10.877,1.407-15.369,4.145
            c-4.502,2.748-8.039,6.608-10.512,11.472c-2.436,4.784-3.666,10.266-3.654,16.293c0.014,6.002,1.367,11.475,4.023,16.266
            c2.682,4.841,6.432,8.667,11.143,11.371c4.666,2.684,10.035,4.043,15.957,4.043h0.078c3.578-0.008,7.352-0.738,11.215-2.172
            c3.891-1.443,7.123-3.322,9.605-5.584l0.119-0.114c1.566-1.573,1.895-3.211,1.895-4.316c-0.004-1.812-0.844-3.492-2.307-4.686
            c-1.082-0.923-2.467-1.411-4.02-1.411c-1.508,0.003-2.975,0.544-4.242,1.564l-0.219,0.192c-1.201,1.154-2.934,2.126-5.145,2.887
            c-2.328,0.8-4.658,1.208-6.982,1.213c-3.383,0-6.344-0.725-9.053-2.216c-2.709-1.492-4.811-3.516-6.424-6.189
            c-1.061-1.752-1.807-3.631-2.25-5.686l38.99-0.083C412.017,64.927,413.548,64.349,414.738,63.238z M398.808,44.691
            c2.27,2.216,3.785,4.932,4.586,8.237l-31.771,0.066c0.902-3.297,2.473-6.016,4.754-8.245c3.016-2.942,6.645-4.377,11.09-4.387
            l0.045-3.351l0,0v3.351C392.132,40.363,395.828,41.779,398.808,44.691z M389.027,88.174L389.027,88.174v0.002V88.174z"
          />
          <path
            fill="#3C71A4"
            d="M127.564,27.948c-17.367,0.037-31.467,14.197-31.432,31.565c0.037,17.331,14.168,31.428,31.498,31.428
            h0.068c17.367-0.037,31.467-14.195,31.43-31.562C159.092,42.047,144.961,27.948,127.564,27.948z M127.67,77.943l-0.039,6.5v-6.5
            c-10.178,0-18.477-8.28-18.498-18.458c-0.021-10.2,8.26-18.516,18.498-18.538c10.178,0,18.477,8.281,18.498,18.459
            C146.15,69.605,137.869,77.921,127.67,77.943z"
          />
        </g>
        <g>
          <path
            fill="#3C71A4"
            d="M53.055,126.885c1.385,0.499,2.788,1.322,4.21,2.47c0.299,0.225,0.499,0.456,0.599,0.692
            c0.099,0.237,0.149,0.518,0.149,0.842c0,0.5-0.181,0.911-0.542,1.235c-0.362,0.324-0.78,0.486-1.254,0.486
            c-0.474,0-0.911-0.162-1.31-0.486c-1.023-0.873-2.021-1.503-2.994-1.89c-0.973-0.387-2.233-0.58-3.78-0.58
            c-1.946,0-3.736,0.512-5.37,1.534c-1.634,1.023-2.932,2.413-3.892,4.172c-0.961,1.76-1.441,3.674-1.441,5.745
            c0,2.096,0.48,4.017,1.441,5.763c0.96,1.746,2.257,3.131,3.892,4.153c1.634,1.023,3.424,1.535,5.37,1.535
            c2.395,0,4.69-0.824,6.886-2.471c0.424-0.299,0.835-0.448,1.235-0.448c0.474,0,0.867,0.168,1.179,0.505
            c0.312,0.337,0.468,0.78,0.468,1.328c0,0.524-0.2,0.986-0.599,1.385c-2.694,2.171-5.751,3.256-9.168,3.256
            c-2.67,0-5.108-0.661-7.316-1.983s-3.948-3.131-5.22-5.426c-1.272-2.296-1.909-4.828-1.909-7.597c0-2.744,0.636-5.258,1.909-7.541
            c1.272-2.282,3.012-4.091,5.22-5.426s4.646-2.002,7.316-2.002C50.03,126.137,51.671,126.386,53.055,126.885z"
          />
          <path
            fill="#3C71A4"
            d="M112.257,128.045c2.257,1.272,4.016,3.044,5.276,5.313c1.259,2.271,1.89,4.853,1.89,7.747
            c0,2.894-0.63,5.481-1.89,7.765c-1.26,2.283-3.013,4.061-5.258,5.333s-4.815,1.908-7.709,1.908c-2.895,0-5.47-0.636-7.728-1.908
            c-2.258-1.272-4.011-3.05-5.258-5.333c-1.248-2.283-1.871-4.871-1.871-7.765c0-2.895,0.624-5.477,1.871-7.747
            c1.247-2.27,3-4.041,5.258-5.313c2.257-1.272,4.833-1.908,7.728-1.908C107.435,126.137,109.999,126.772,112.257,128.045z
            M98.822,131.15c-1.684,0.999-3,2.371-3.948,4.117c-0.948,1.746-1.422,3.692-1.422,5.838s0.474,4.092,1.422,5.838
            c0.948,1.746,2.27,3.124,3.967,4.135c1.696,1.011,3.605,1.516,5.726,1.516c2.12,0,4.029-0.505,5.726-1.516
            c1.696-1.011,3.019-2.389,3.967-4.135c0.948-1.746,1.422-3.692,1.422-5.838s-0.474-4.092-1.422-5.838
            c-0.948-1.746-2.264-3.118-3.948-4.117c-1.684-0.997-3.599-1.496-5.744-1.496C102.42,129.654,100.506,130.153,98.822,131.15z"
          />
          <path
            fill="#3C71A4"
            d="M172.749,127.053c0.374-0.361,0.835-0.542,1.385-0.542c0.548,0,1.004,0.181,1.366,0.542
            c0.361,0.362,0.542,0.83,0.542,1.403v25.335c0,0.574-0.181,1.042-0.542,1.403c-0.362,0.362-0.817,0.543-1.366,0.543
            c-0.275,0-0.556-0.057-0.842-0.169c-0.287-0.112-0.505-0.28-0.655-0.505l-16.316-21.705v20.433c0,0.549-0.181,1.011-0.542,1.385
            c-0.362,0.374-0.83,0.562-1.403,0.562c-0.549,0-1.005-0.181-1.366-0.543c-0.362-0.361-0.542-0.829-0.542-1.403v-25.335
            c0-0.573,0.181-1.041,0.542-1.403c0.361-0.361,0.817-0.542,1.366-0.542c0.274,0,0.548,0.068,0.823,0.206
            c0.274,0.137,0.499,0.306,0.673,0.505l16.316,21.704v-20.47C172.188,127.883,172.375,127.415,172.749,127.053z"
          />
          <path
            fill="#3C71A4"
            d="M230.752,127.053c0.374-0.361,0.835-0.542,1.385-0.542c0.548,0,1.004,0.181,1.365,0.542
            c0.361,0.362,0.543,0.83,0.543,1.403v25.335c0,0.574-0.182,1.042-0.543,1.403c-0.361,0.362-0.817,0.543-1.365,0.543
            c-0.275,0-0.556-0.057-0.843-0.169s-0.505-0.28-0.654-0.505l-16.316-21.705v20.433c0,0.549-0.181,1.011-0.542,1.385
            c-0.362,0.374-0.83,0.562-1.403,0.562c-0.549,0-1.005-0.181-1.366-0.543c-0.362-0.361-0.542-0.829-0.542-1.403v-25.335
            c0-0.573,0.181-1.041,0.542-1.403c0.361-0.361,0.817-0.542,1.366-0.542c0.274,0,0.548,0.068,0.823,0.206
            c0.274,0.137,0.499,0.306,0.673,0.505l16.316,21.704v-20.47C230.191,127.883,230.378,127.415,230.752,127.053z"
          />
          <path
            fill="#3C71A4"
            d="M288.718,152.631c0.349,0.324,0.523,0.749,0.523,1.272c0,0.549-0.175,0.992-0.523,1.328
            c-0.35,0.337-0.812,0.506-1.385,0.506h-16.915c-0.549,0-1.01-0.188-1.384-0.562c-0.375-0.374-0.562-0.836-0.562-1.385v-25.335
            c0-0.573,0.187-1.041,0.562-1.403c0.374-0.361,0.835-0.542,1.384-0.542h16.915c0.573,0,1.035,0.168,1.385,0.505
            c0.349,0.337,0.523,0.78,0.523,1.328c0,0.524-0.175,0.949-0.523,1.272c-0.35,0.325-0.812,0.486-1.385,0.486h-14.969v9.094h10.74
            c0.549,0,1.004,0.169,1.366,0.506c0.361,0.336,0.542,0.767,0.542,1.291c0,0.523-0.181,0.954-0.542,1.291
            c-0.362,0.337-0.817,0.505-1.366,0.505h-10.74v9.355h14.969C287.907,152.145,288.369,152.307,288.718,152.631z"
          />
          <path
            fill="#3C71A4"
            d="M339.63,126.885c1.385,0.499,2.788,1.322,4.21,2.47c0.3,0.225,0.499,0.456,0.599,0.692
            c0.1,0.237,0.15,0.518,0.15,0.842c0,0.5-0.182,0.911-0.543,1.235c-0.362,0.324-0.78,0.486-1.254,0.486s-0.911-0.162-1.31-0.486
            c-1.023-0.873-2.021-1.503-2.994-1.89c-0.973-0.387-2.232-0.58-3.779-0.58c-1.946,0-3.736,0.512-5.37,1.534
            c-1.634,1.023-2.932,2.413-3.892,4.172c-0.961,1.76-1.441,3.674-1.441,5.745c0,2.096,0.48,4.017,1.441,5.763
            c0.96,1.746,2.258,3.131,3.892,4.153c1.634,1.023,3.424,1.535,5.37,1.535c2.396,0,4.69-0.824,6.886-2.471
            c0.424-0.299,0.836-0.448,1.235-0.448c0.473,0,0.866,0.168,1.179,0.505c0.312,0.337,0.468,0.78,0.468,1.328
            c0,0.524-0.2,0.986-0.6,1.385c-2.694,2.171-5.75,3.256-9.168,3.256c-2.67,0-5.108-0.661-7.316-1.983
            c-2.207-1.322-3.947-3.131-5.22-5.426c-1.272-2.296-1.909-4.828-1.909-7.597c0-2.744,0.637-5.258,1.909-7.541
            c1.272-2.282,3.013-4.091,5.22-5.426c2.208-1.335,4.646-2.002,7.316-2.002C336.605,126.137,338.246,126.386,339.63,126.885z"
          />
          <path
            fill="#3C71A4"
            d="M397.559,127.016c0.337,0.337,0.506,0.768,0.506,1.291c0,0.524-0.169,0.954-0.506,1.291
            c-0.336,0.337-0.767,0.505-1.291,0.505h-8.045v23.688c0,0.549-0.188,1.011-0.562,1.385s-0.836,0.562-1.385,0.562
            s-1.011-0.188-1.385-0.562s-0.562-0.836-0.562-1.385v-23.688h-8.083c-0.523,0-0.954-0.168-1.291-0.505s-0.505-0.767-0.505-1.291
            c0-0.523,0.168-0.954,0.505-1.291s0.768-0.505,1.291-0.505h20.021C396.792,126.511,397.223,126.679,397.559,127.016z"
          />
        </g>
        <g>
          <radialGradient
            id="SVGID_1_"
            cx="46.3608"
            cy="59.9551"
            r="44.2522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_1_)"
            d="M77.354,59.191c-0.029-13.337-8.427-24.75-20.197-29.274l0.013,7.621H34.421l-0.014-7.521
            c-3.987,1.567-7.64,3.947-10.747,7.068c-5.922,5.948-9.174,13.846-9.156,22.241c0.027,13.27,8.342,24.632,20.021,29.202
            l-0.014-7.614h22.752l0.013,7.657c4.05-1.566,7.767-3.97,10.922-7.139C74.12,75.484,77.372,67.586,77.354,59.191z
            M58.257,71.533c-3.279,3.293-7.644,5.112-12.29,5.122H45.93c-9.574,0-17.378-7.788-17.396-17.361
            c-0.011-4.646,1.789-9.019,5.068-12.311s7.645-5.112,12.293-5.121c9.608,0,17.41,7.787,17.431,17.359
            C63.336,63.867,61.536,68.24,58.257,71.533z"
          />
          <radialGradient
            id="SVGID_2_"
            cx="46.3599"
            cy="59.9551"
            r="44.2531"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_2_)"
            d="M90.724,79.795v-41.06c-6.292-13.666-18.65-23.98-33.599-27.471l0.023,13.48
            c14.534,4.746,25.059,18.385,25.093,34.437c0.021,9.699-3.737,18.826-10.58,25.698c-4.098,4.115-9.012,7.119-14.375,8.876
            l0.022,13.377h0.334C72.368,103.529,84.508,93.297,90.724,79.795z"
          />
          <radialGradient
            id="SVGID_3_"
            cx="46.3604"
            cy="59.9551"
            r="44.2529"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_3_)"
            d="M34.218,107.133h0.339l-0.023-13.408C20.109,88.938,9.65,75.335,9.616,59.335
            c-0.021-9.7,3.737-18.827,10.581-25.7c4.054-4.07,8.906-7.051,14.201-8.818l-0.024-13.471C19.578,14.916,7.373,25.17,1.135,38.721
            v41.062C7.354,93.289,19.5,103.525,34.218,107.133z"
          />
          <radialGradient
            id="SVGID_4_"
            cx="46.3604"
            cy="59.9551"
            r="44.2528"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_4_)"
            d="M45.932,46.749c-3.369,0.007-6.509,1.315-8.867,3.682c-2.357,2.367-3.652,5.512-3.645,8.853
            c0.014,6.884,5.626,12.484,12.51,12.484v2.443l0.027-2.443c3.341-0.007,6.479-1.315,8.837-3.683
            c2.357-2.368,3.651-5.512,3.644-8.854C58.424,52.349,52.813,46.749,45.932,46.749z"
          />
          <radialGradient
            id="SVGID_5_"
            cx="46.3608"
            cy="59.9551"
            r="44.2527"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_5_)"
            d="M90.724,28.828V11.251H70.99C78.92,15.411,85.706,21.468,90.724,28.828z"
          />
          <radialGradient
            id="SVGID_6_"
            cx="46.3613"
            cy="59.9551"
            r="44.253"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_6_)"
            d="M20.859,11.251H1.135v17.57C6.149,21.465,12.93,15.409,20.859,11.251z"
          />
          <radialGradient
            id="SVGID_7_"
            cx="46.3604"
            cy="59.9526"
            r="44.2547"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_7_)"
            d="M1.135,89.688v17.445H20.61C12.791,102.977,6.099,96.969,1.135,89.688z"
          />
          <radialGradient
            id="SVGID_8_"
            cx="46.3604"
            cy="59.9526"
            r="44.254"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2EFFF1" />
            <stop offset="0.3193" stopColor="#33CED6" />
            <stop offset="0.7822" stopColor="#398BB2" />
            <stop offset="1" stopColor="#3C71A4" />
          </radialGradient>
          <path
            fill="url(#SVGID_8_)"
            d="M71.257,107.133h19.467V89.693C85.763,96.971,79.076,102.979,71.257,107.133z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
